(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {

    document.querySelectorAll('[data-promo-countdown]').forEach(function (el) {
      var daysEl = el.querySelector('[data-cd-days]');
      var hoursEl = el.querySelector('[data-cd-hours]');
      var minutesEl = el.querySelector('[data-cd-minutes]');
      var secondsEl = el.querySelector('[data-cd-seconds]');
      var END = new Date(el.dataset.end).getTime();

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function update() {
        var remaining = END - Date.now();
        if (!(remaining > 0)) {
          var sec = el.closest('.shopify-section');
          if (sec) sec.hidden = true;
          return false;
        }

        var totalSeconds = Math.floor(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
        return true;
      }

      if (update()) setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
